// Set the key we'll use in local storage.
// Go to Chrome dev tools, application tab, click "Local Storage" and "http://localhost:8080"
// and you'll see this key set below (if logged in):
export const STORAGE_KEY = "PortalStorage";

let syncedData = {
  auth: {
    isLoggedIn: false,
    accessToken: null,
    refreshToken: null
  },
  user: {
    userId: null,
    userName: null,
    nickName: null,
    loginType: null,
    avatarUrl: null,
    departName: null,
    departId: null,
    agenttype: null,
    roles: null
  }
};

// Sync with local storage.
if (localStorage.getItem(STORAGE_KEY)) {
  syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY));
}

let ui = {
  tableHeight: 0,
  navCollapsed:false,
  pageBackground: "#f2f4f6",
  searchValue:""
};
let model = {
  isStore:false     //切换模式，false为标准版，true为商城版
};
// Merge data and export it.
export const state = Object.assign(syncedData, ui,model);



// WEBPACK FOOTER //
// ./src/store/state.js